import { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../services/api';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setMessage('');
    setLoading(true);
    try {
      await api.post('/auth/forgot-password', { email });
      setMessage('Email enviado! Verifique sua caixa de entrada.');
    } catch (err) {
      setError(err.response?.data?.error || 'Erro ao enviar o email.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <main className="page-container form-page">
      <h2>Esqueceu a senha?</h2>
      <form onSubmit={handleSubmit} className="form-card">
        {error && <div className="alert-error">{error}</div>}
        {message && <div className="alert-success">{message}</div>}
        <p style={{ color: '#475569', fontSize: '0.9rem', margin: 0 }}>
          Digite seu email e enviaremos um link para redefinir sua senha.
        </p>
        <label>
          Email
          <input
            type="email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
            autoComplete="email"
          />
        </label>
        <button type="submit" className="btn-primary" disabled={loading}>
          {loading ? 'Enviando...' : 'Enviar link'}
        </button>
        <Link to="/login" style={{ textAlign: 'center', fontSize: '0.9rem' }}>
          Voltar ao login
        </Link>
      </form>
    </main>
  );
}
